import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Cons from '../../isomorphic/cons';
import SimpleEmailAuditStep from './steps/audit/simple-email-audit-step';
import DeadlineCalculatedHelper from './../utils/deadline-calculated-helper';
import moment from 'moment';

@inject('appStore')
@observer
export default class AuditWorkflow extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const accordionId = 'audit-workflow-accordion';

        const combinedWorkflowSteps = this.props.appStore.workflowStore.workflow
            .map(step => {
                return {
                    step: step,
                    deadlineCalculated: DeadlineCalculatedHelper.getDeadlineCalculated(
                        step,
                        this.props.appStore.workflowStore.calendarTimelineStepState
                    ),
                };
            })
            .filter(step => step.deadlineCalculated); //Only return step's that have deadlineCalculated data (remove initiation steps)

        combinedWorkflowSteps.sort((a, b) => new Date(a.deadlineCalculated) - new Date(b.deadlineCalculated));

        const renderSteps = () => {
            const steps = combinedWorkflowSteps.map(stepBag => {
                switch (stepBag.step.type) {
                    case 'ernest-money-deposit': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'earnest-money-deposit-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                    return 'earnest-money-deposit-listing-gone-pending';
                                case Cons.saleTypes['Double Ended']:
                                    return 'earnest-money-deposit-double-ended';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                className={'earnest-money-deposit-step'}
                                accordionId={accordionId}
                                options={{
                                    question: 'The Earnest Money Deposit (EMD) is in',
                                    templateTag: getTemplateTag(),
                                }}
                            />
                        );
                    }
                    case 'fully-executed-disclosures': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'fully-executed-disclosures-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                    return 'fully-executed-disclosures-listing-gone-pending';
                                case Cons.saleTypes['Double Ended']:
                                    return 'fully-executed-disclosures-double-ended';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                className={'fully-executed-disclosures-step'}
                                accordionId={accordionId}
                                options={{
                                    question:
                                        'Fully Executed Disclosures (signed by both the Seller and Buyer) have been received',
                                    templateTag: getTemplateTag(),
                                }}
                            />
                        );
                    }
                    case 'seller-disclosures-due': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'seller-signed-disclosures-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                case Cons.saleTypes['Double Ended']:
                                    return 'seller-signed-disclosures-listing-gone-pending';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                accordionId={accordionId}
                                className={'seller-disclosures-due-step'}
                                options={{
                                    question: 'Disclosures signed by the Seller have been received',
                                    templateTag: getTemplateTag(),
                                }}
                            />
                        );
                    }
                    case 'contingency-on-sale-or-purchase': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'contingency-removal-COP-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                    return 'contingency-removal-COP-listing-gone-pending';
                                case Cons.saleTypes['Double Ended']:
                                    return 'contingency-removal-COP-double-ended';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                accordionId={accordionId}
                                className={'contingency-on-sale-or-purchase'}
                                options={{
                                    question: 'The COP has been satisfied',
                                    templateTag: getTemplateTag(),
                                    extraTemplateData: {
                                        crtype: 'COP',
                                    },
                                }}
                            />
                        );
                    }
                    case 'inspection-contingency-due': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'contingency-removal-inspection-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                    return 'contingency-removal-inspection-listing-gone-pending';
                                case Cons.saleTypes['Double Ended']:
                                    return 'contingency-removal-inspection-double-ended';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                accordionId={accordionId}
                                className={'inspection-contingency-due'}
                                options={{
                                    question: 'The Inspection Contingency Removal has been received',
                                    templateTag: getTemplateTag(),
                                    extraTemplateData: {
                                        crtype: 'Inspection',
                                    },
                                }}
                            />
                        );
                    }
                    case 'appraisal-contingency-due': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'contingency-removal-appraisal-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                    return 'contingency-removal-appraisal-listing-gone-pending';
                                case Cons.saleTypes['Double Ended']:
                                    return 'contingency-removal-appraisal-double-ended';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                accordionId={accordionId}
                                className={'appraisal-contingency-due'}
                                options={{
                                    question: 'The Appraisal Contingency Removal has been received',
                                    templateTag: getTemplateTag(),
                                    extraTemplateData: {
                                        crtype: 'Appraisal',
                                    },
                                }}
                            />
                        );
                    }
                    case 'loan-contingency-due': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'contingency-removal-loan-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                    return 'contingency-removal-loan-listing-gone-pending';
                                case Cons.saleTypes['Double Ended']:
                                    return 'contingency-removal-loan-double-ended';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                accordionId={accordionId}
                                className={'loan-contingency-due'}
                                options={{
                                    question: 'The Loan Contingency Removal has been received',
                                    templateTag: getTemplateTag(),
                                    extraTemplateData: {
                                        crtype: 'Loan',
                                    },
                                }}
                            />
                        );
                    }
                    case 'scheduled-close-of-escrow': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'close-of-escrow-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                    return 'close-of-escrow-listing-gone-pending';
                                case Cons.saleTypes['Double Ended']:
                                    return 'close-of-escrow-double-ended';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                hideNaAction
                                hideWaitingAction
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                accordionId={accordionId}
                                className={'scheduled-close-of-escrow'}
                                options={{
                                    question: 'Escrow has closed',
                                    templateTag: getTemplateTag(),
                                }}
                            />
                        );
                    }

                    case 'closing-congrats': {
                        const getTemplateTag = () => {return 'closing-congrats';};

                        return (
                            <SimpleEmailAuditStep
                                hideDueDate
                                hideNaAction
                                hideWaitingAction
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                accordionId={accordionId}
                                className={'closing-congrats'}
                                options={{
                                    question: 'Close congrats',
                                    templateTag: getTemplateTag(),
                                }}
                            />
                        );
                    }
                    
                    case 'closing-checkins': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'closing-checkins-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                    return 'closing-checkins-listing-gone-pending';
                                case Cons.saleTypes['Double Ended']:
                                    return 'closing-checkins-double-ended';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                hideDueDate
                                hideNaAction
                                hideWaitingAction
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                accordionId={accordionId}
                                className={'closing-checkins'}
                                options={{
                                    question: 'This file is complete',
                                    templateTag: getTemplateTag(),
                                }}
                            />
                        );
                    }
                    case 'cancellation': {
                        const getTemplateTag = () => {
                            switch (this.props.appStore.tcFileStore.selectedFile.typeOfSale) {
                                case Cons.saleTypes['Sale']:
                                    return 'cancellation-sale';
                                case Cons.saleTypes['Listing Gone Pending']:
                                    return 'cancellation-listing-gone-pending';
                                case Cons.saleTypes['Double Ended']:
                                    return 'cancellation-double-ended';
                                default:
                                    return '';
                            }
                        };

                        return (
                            <SimpleEmailAuditStep
                                hideWaitingAction
                                hideDueDate
                                key={stepBag.step.stepId}
                                step={stepBag.step}
                                deadlineCalculated={stepBag.deadlineCalculated}
                                accordionId={accordionId}
                                className={'cancellation'}
                                options={{
                                    question: 'A fully executed cancellation has been received',
                                    templateTag: getTemplateTag(),
                                }}
                            />
                        );
                    }
                    default:
                        return null;
                }
            });

            return steps;
        };

        return (
            <div className="panel-group audit-workflow" id={accordionId}>
                <h3>Audit Steps</h3>

                {renderSteps()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/audit-workflow.js